import type { TOC } from '@ember/component/template-only';

interface LpnSchoolLogoSignature {
  Args: {
    /** The school's uploaded logo; null or empty shows the school's initials instead. */
    src: string | null | undefined;
    /** Shown in place of a missing logo; see `schoolInitials`. */
    initials: string;
    /** `tile` sits at the end of a school row; `banner` heads the detail view. */
    size: 'tile' | 'banner';
  };
}

/**
 * A school logo at a fixed size, so differently shaped logos line up: right-aligned in a list row,
 * left-aligned heading the detail view.
 */
const LpnSchoolLogo: TOC<LpnSchoolLogoSignature> = <template>
  <div
    class="shrink-0 overflow-hidden
      {{if (eq @size 'banner') 'tio-row h-24 w-full' 'tio-row-end h-20 w-36'}}"
    data-test-lpn-school-logo
  >
    {{#if @src}}
      <img src={{@src}} alt="" class="h-full max-w-full object-contain" />
    {{else}}
      <span
        class="tio-fg-brand
          {{if (eq @size 'banner') 'tio-text-2xl-semibold' 'tio-text-lg-semibold'}}"
        aria-hidden="true"
      >{{@initials}}</span>
    {{/if}}
  </div>
</template>;

export default LpnSchoolLogo;
